import React from 'react'
import { RadialGauge } from '@progress/kendo-react-gauges'

import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'
import Link from '@mui/material/Link'

const radialOptions = {
  pointer: {
    value: 3,
    color: 'rgb(71,74,79)',
    length: 0.7,
  },
  scale: {
    labels: {
      position: 'outside',
      content: value => {
        if (Number.isInteger(value.value)) {
          return value.text
        } else {
          return ''
        }
      },
    },
    min: 1,
    max: 5,
    ranges: [
      {
        from: 1,
        to: 1.5,
        color: '#00CBA9',
      },
      {
        from: 1.5,
        to: 2,
        color: '#00CBA9',
      },
      {
        from: 2,
        to: 2.5,
        color: '#0099FF',
      },
      {
        from: 2.5,
        to: 3,
        color: '#0099FF',
      },
      {
        from: 3,
        to: 3.5,
        color: '#0099FF',
      },
      {
        from: 3.5,
        to: 4,
        color: '#0099FF',
      },
      {
        from: 4,
        to: 4.5,
        color: '#D14343',
      },
      {
        from: 4.5,
        to: 5,
        color: '#D14343',
      },
    ],
    minorTicks: {
      visible: false,
    },
    majorTicks: {
      visible: false,
    },
    endAngle: 180,
    startAngle: 0,
    rangeSize: 30,
  },
}

const RiskClassTooltipContent = () => {
  return (
    <Box>
      <Typography component={'div'} variant={'body2'} sx={{ marginBottom: '10px' }} color={'white'}>
        The Business Credit Risk Class is provided by Equifax, and is generally used with the Business Credit Risk Score
        to determine the likelihood of a business becoming severely delinquent on a non-financial account. Severely
        delinquent means 90+ days delinquent on payment, charged off, or bankrupt in the next 12 months. The higher the
        risk class, the higher the risk of severe delinquency. According to Equifax, a score of 5 is 4 times that of the
        US average and over 100 times the risk of a score of 1.
      </Typography>
      <Typography
        component={'div'}
        variant={'body2'}
        color={'white'}
        sx={{ padding: '10px 0', marginBottom: '10px' }}
      >
        Visit{' '}
        <Link href="https://www.equifax.com/" underline="hover" target="_blank" rel="noopener noreferrer" sx={{ cursor: 'pointer', textDecorationColor: 'white !important' }} >
          <Typography component="span" variant="button2" color="white">
            Equifax.com
          </Typography>
        </Link>
        &nbsp;for more information.
      </Typography>
      <Box width='300px' height='191px' backgroundColor='white' borderRadius='10px'>
      <RadialGauge {...radialOptions} />
      </Box>
    </Box>
  )
}

export default RiskClassTooltipContent
